<template>
    <div>
        <ButtonComp
            class="p-0 m-0"
            icon="fa-chart-line"
            button-type="Custom"
            @click="openDeviceStatistics"
        />
    </div>
</template>
<script setup lang="ts">
import ButtonComp from '@/components/Basic/ButtonComp.vue';
import { useDialog } from '@/composeables';
import DeviceStatistics from './DeviceStatistics.vue';
import { $tm } from '@/locize';
import type { StationDeviceStatusWithCount } from '@/objects/generated';

const props = defineProps<{
    value: string;
    row?: StationDeviceStatusWithCount;
}>();

const openDeviceStatistics = () => {
    useDialog().Ok({
        title: 'device.statistics',
        body: DeviceStatistics,
        componentProps: {
            deviceId: props.value,
            row: props.row,
        },
        options: {
            Size: 'xxl',
        },
    });
};
</script>
